import angular from 'angular';
import pipelineItemLabels from './pipelineItemLabels';
import './style.scss';

export default angular
  .module('components.pipelineItemLabels', [])
  .component('pipelineItemLabels', pipelineItemLabels).name;
